export default "__VITE_PUBLIC_ASSET__eb136512__"